import { WithResourceId } from '@mews-commander/types';
import { useResourceName } from './useResourceName';

export const ResourceName = ({ resourceId }: WithResourceId) => {
    const { resourceName } = useResourceName({ resourceId });

    return resourceName ? <>{resourceName}</> : null;
};
